"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var SsisGet = function () {
  function SsisGet() {
    (0, _classCallCheck3.default)(this, SsisGet);

    this.guestData = localStorage.getItem("guestData") === null ? null : JSON.parse(localStorage.getItem("guestData"));
    this.data = [];
    this.prescriptionLookupTables = document.querySelectorAll(".js-prescription-table");
    this.orderWrapper = document.querySelector(".js-order-wrapper");
    this.loggedin_email = this.orderWrapper.dataset.email;

    if (this.loggedin_email) {
      if (this.guestData === null) {
        this.email_address = this.loggedin_email;
      } else {
        this.email_address = this.loggedin_email + "," + this.guestData.email_address;
      }
    } else {
      this.email_address = this.guestData != null ? this.guestData.email_address : "";
    }

    this.url = "https://www.sunniessystems.com/api/3.0/324566/prescriptions/";
    this.apiKey = "052398FSOWRI2UR7FHJKG789403JHFSA";
    this.headers = { "oassis-api-key": this.apiKey };
    this.params = {
      email_address: this.email_address,
      client_id: "95jgnvudiht03075kdhfrw256789dhif",
      patient_id: ""
    };
  }

  (0, _createClass3.default)(SsisGet, [{
    key: "init",
    value: function init() {
      var _this = this;

      var prescriptionLookupTables = this.prescriptionLookupTables,
          url = this.url,
          headers = this.headers,
          params = this.params;

      if (prescriptionLookupTables.length > 0) {
        (0, _axios2.default)({
          url: url,
          method: "get",
          headers: headers,
          params: params
        }).then(function (result) {
          _this.mapPrescription(result.data);
          return true;
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  }, {
    key: "mapPrescription",
    value: function mapPrescription(prescriptions) {
      var data = this.data;

      var dataArrays = prescriptions.prescriptions_historical.concat(prescriptions.prescriptions_processing);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = dataArrays[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var prescription = _step.value;

          var object = {
            id: prescription.prescription_id,
            row_id: prescription.row_id,
            prescriptionSet: false,
            newPrescription: false,
            store: prescription.branch_name,
            date: prescription.date_updated,
            type: prescription.prescription_purpose,
            left: {
              sph: prescription.sph_os,
              cyl: prescription.cyl_os,
              axis: prescription.axis_os,
              add: prescription.add_os,
              ipd: prescription.ipd_os,
              ph: prescription.ph_os
            },
            right: {
              sph: prescription.sph_od,
              cyl: prescription.cyl_od,
              axis: prescription.axis_od,
              add: prescription.add_od,
              ipd: prescription.ipd_od,
              ph: prescription.ph_od
            },
            frame: prescription.frame_name,
            lens: prescription.lens_name
          };

          data.push(object);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.buildTables(data);
    }
  }, {
    key: "buildTables",
    value: function buildTables(prescriptionData) {
      var prescriptionLookupTables = this.prescriptionLookupTables;

      var _loop = function _loop(table) {
        var prescriptionId = table.dataset.prescriptionId;
        var tableData = prescriptionData.filter(function (object) {
          return object.prescription_id === prescriptionId || object.id === prescriptionId;
        })[0];

        table.querySelector('[data-type="os-sph"]').innerText = tableData.left.sph;
        table.querySelector('[data-type="os-cyl"]').innerText = tableData.left.cyl;
        table.querySelector('[data-type="os-axis"]').innerText = tableData.left.axis;
        table.querySelector('[data-type="os-add"]').innerText = tableData.left.add;
        table.querySelector('[data-type="os-ipd"]').innerText = tableData.left.ipd;

        table.querySelector('[data-type="od-sph"]').innerText = tableData.right.sph;
        table.querySelector('[data-type="od-cyl"]').innerText = tableData.right.cyl;
        table.querySelector('[data-type="od-axis"]').innerText = tableData.right.axis;
        table.querySelector('[data-type="od-add"]').innerText = tableData.right.add;
        table.querySelector('[data-type="od-ipd"]').innerText = tableData.right.ipd;
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {

        for (var _iterator2 = prescriptionLookupTables[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var table = _step2.value;

          _loop(table);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }]);
  return SsisGet;
}();

exports.default = SsisGet;